'use client'

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // smooth 애니메이션 없이 즉시 최상단으로
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0; // Safari 대응
  }, [pathname]);

  return null;
}
